import Http from '../http';

const prefix = '/website-vote-system';

export const get = id => {
  return Http.authApiV2().get(`${prefix}?website_id=${id}`);
};

export const getOne = id => {
  return Http.authApiV2().get(`${prefix}/${id}`);
};

export const create = params => Http.authApiV2().post(`${prefix}`, params);

export const update = (question, data) => {
  return Http.authApiV2().put(`${prefix}/${question.id}`, { options : data });
};

export const destroy = id => {
  return Http.authApiV2().delete(`${prefix}/${id.id}`,);
};


// WEBPACK FOOTER //
// ./src/js/services/editor/votesystem.js